var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.facility=='app')?_c('div',{staticClass:"app"}):_c('div',{staticClass:"pc_exhibit"},[_c('Zp')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }